var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8437_36072)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.25,
    cy: 8.25,
    r: 4.75,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 14.5832C3.5882 14.5832 0.416992 11.412 0.416992 7.49984C0.416992 3.58771 3.5882 0.416504 7.50033 0.416504C11.4125 0.416504 14.5837 3.58771 14.5837 7.49984C14.5837 11.412 11.4125 14.5832 7.50033 14.5832ZM6.79199 9.62484V11.0415H8.20866V9.62484H6.79199ZM8.20866 8.45963C8.77793 8.28805 9.26663 7.91772 9.58577 7.41607C9.90491 6.91442 10.0333 6.31483 9.94743 5.7265C9.8616 5.13817 9.56732 4.60023 9.11817 4.21066C8.66902 3.82109 8.09488 3.6058 7.50033 3.604C6.92718 3.60396 6.37171 3.80245 5.92839 4.16571C5.48506 4.52897 5.18125 5.03458 5.06862 5.59655L6.45837 5.87492C6.49781 5.6776 6.59247 5.49554 6.73134 5.34992C6.8702 5.20429 7.04757 5.1011 7.24279 5.05234C7.43802 5.00358 7.64308 5.01126 7.83411 5.07448C8.02514 5.13771 8.19429 5.25388 8.32187 5.40948C8.44946 5.56508 8.53024 5.75372 8.55481 5.95343C8.57938 6.15315 8.54673 6.35574 8.46066 6.53763C8.3746 6.71951 8.23865 6.87322 8.06864 6.98086C7.89863 7.08851 7.70155 7.14566 7.50033 7.14567C7.31246 7.14567 7.1323 7.2203 6.99946 7.35314C6.86662 7.48598 6.79199 7.66614 6.79199 7.854V8.9165H8.20866V8.45963Z",
    fill: "#FF8A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8437_36072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/questionCircle.dbc75a631ce4f20b163a7ef963c9dae3.svg";
export { ForwardRef as ReactComponent };